import { render, staticRenderFns } from "./TicketSpread.vue?vue&type=template&id=6d787c10&"
import script from "./TicketSpread.vue?vue&type=script&lang=js&"
export * from "./TicketSpread.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports